import React from 'react';

// Ratna Sthapna comparison table — three Granths side by side. Renders only for layerId 'RATNA-STHAPNA'.
const RatnaSthapnaTable = ({ layerId }) => {
  if (layerId !== 'RATNA-STHAPNA') return null;

  const RATNA_DATA = [
    { srNo: 1, maanasaram: 'Ruby',             mayamatham: 'Ruby',             aparajita: 'Ruby',                  mayaSymbol: 'pentagon' },
    { srNo: 2, maanasaram: 'Diamond',          mayamatham: 'Red coral',        aparajita: 'Crystal Quartz/Diamond', mayaSymbol: 'star' },
    { srNo: 3, maanasaram: 'Red coral',        mayamatham: 'Yellow Sapphire',  aparajita: "Cat's Eye",             mayaSymbol: 'star' },
    { srNo: 4, maanasaram: 'Blue sapphire',    mayamatham: "Cat's Eye",        aparajita: 'Pearl',                 mayaSymbol: 'star' },
    { srNo: 5, maanasaram: 'Yellow Sapphire',  mayamatham: 'Diamond',          aparajita: 'Blue sapphire',         mayaSymbol: 'star' },
    { srNo: 6, maanasaram: 'Green Emerald',    mayamatham: 'Blue sapphire',    aparajita: 'Blue sapphire',         mayaSymbol: 'star' },
    { srNo: 7, maanasaram: 'Hessonite Gernet', mayamatham: 'Blue sapphire',    aparajita: 'Yellow Sapphire',       mayaSymbol: 'star' },
    { srNo: 8, maanasaram: 'Pearl',            mayamatham: 'Green Emerald',    aparajita: 'Hessonite Gernet',      mayaSymbol: 'star' },
    { srNo: 9, maanasaram: "Cat's Eye",        mayamatham: 'Pearl',            aparajita: 'Red coral',             mayaSymbol: 'star' },
  ];

  const col1 = RATNA_DATA;
  const col2 = RATNA_DATA;
  const col3 = RATNA_DATA;

  return (
    <div style={{
      marginTop: '20px', padding: '16px',
      backgroundColor: '#f5f5f5', borderRadius: '8px',
      border: '1px solid #ddd', width: '1000px',
    }}>
      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '20px', marginBottom: '12px',
      }}>
        {['Maanasaram Granth', 'Mayamatham Granth', 'Aparajitaprccha Granth'].map((title, i) => (
          <div key={i} style={{
            backgroundColor: '#00A19D', color: '#fff',
            padding: '8px 12px', fontWeight: 'bold', fontSize: '12px',
            borderRadius: '4px', textAlign: 'center',
          }}>{title}</div>
        ))}
      </div>

      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px',
      }}>
        {[col1, col2, col3].map((col, colIdx) => (
          <div key={colIdx} style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
            {col.map((item, idx) => {
              let symbol = '⬟';
              let symbolColor = '#c8922a';
              if (colIdx === 1 && item.srNo !== 1) {
                symbol = '★';
                symbolColor = '#1a3c8f';
              }
              return (
                <div
                  key={`col${colIdx + 1}-${item.srNo}`}
                  style={{
                    display: 'grid', gridTemplateColumns: '40px 1fr 30px', gap: '4px',
                    padding: '6px 8px',
                    backgroundColor: idx % 2 === 0 ? '#fff' : '#f9f9f9',
                    borderBottom: '1px solid #eee', fontSize: '11px',
                    alignItems: 'center',
                  }}
                >
                  <span style={{ fontWeight: 'bold', color: '#00A19D', textAlign: 'center' }}>
                    {item.srNo}
                  </span>
                  <span style={{ color: '#333' }}>
                    {colIdx === 0 ? item.maanasaram : colIdx === 1 ? item.mayamatham : item.aparajita}
                  </span>
                  <span style={{ fontSize: '14px', textAlign: 'center', color: symbolColor, fontWeight: 'bold' }}>
                    {symbol}
                  </span>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RatnaSthapnaTable;
